import { FileTextOutlined, InfoCircleOutlined } from "@ant-design/icons";
import React from "react";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

type InfoBannerProps = {
  applyOverpaymentCredit?: boolean;
};

export const InfoBanner: React.FC<InfoBannerProps> = ({ applyOverpaymentCredit = false }) => (
  <div className={applyOverpaymentCredit ? styles.infoBannerCredit : styles.infoBanner}>
    {applyOverpaymentCredit ? (
      <InfoCircleOutlined className={styles.infoBannerCreditIcon} />
    ) : (
      <FileTextOutlined className={styles.infoBannerIcon} />
    )}
    <span className={applyOverpaymentCredit ? styles.infoBannerCreditText : styles.infoBannerText}>
      {applyOverpaymentCredit ? (
        <>
          No new receipt. The tenant&apos;s <strong>existing credit</strong> is applied to the selected invoices; any
          unused credit stays on their balance.
        </>
      ) : (
        "A single receipt will be issued against all selected invoices, referencing the payment details below."
      )}
    </span>
  </div>
);
